import emdOwlData from '../demo/hbz.emd.owl.json';
import iepOwlData from '../demo/hbz.iep.stamm.owl.json';
//Возвращает примеры результатов выполнения запроса к simbix
//Используется для тестирования визуальных компонент, пока не реализован
//сервиса simbix

export const responseConceptScheme = {
    version: 1.0,
    schemes: [
        {
            name: 'По типу',
            concepts: [{ name: 'Внешние' }, { name: 'Внутренние' }]
        },
        {
            name: 'По виду',
            concepts: [{ name: 'Глоссарий' }, { name: 'Закрытый список' }]
        }
    ]
};

//Список ключевых слов
export const responseTags = {
    version: 1.0,
    tags: [
        { name: 'Медицина', count: 31 },
        { name: 'Тезаурус', count: 2 },
        { name: 'Concept', count: 3 },
    ]
}

//Список доступных языков
export const responseLangs = {
    version: 1.0,
    langs: [
        { name: 'Все языки', lang: '' },
        { name: 'Русский', lang: 'ru' },
        { name: 'Английский', lang: 'en' },
    ]
}

//Список ассетов
export const responseAssets = {
    version: 1.0,
    assets: [
        { name: 'Онтология EuroVoc', description: 'Онтология EuroVoc является расширением SKOS (Simple Knowledge Organization System) - рекомендации W3C, включая приложение B, SKOS eXtension for Labels (SKOS-XL). EuroVoc использует семантические веб-технологии, которые отражают рекомендации W3C и последние тенденции в стандартах тезауруса. EuroVoc 4.5: онтология EuVoc и профиль приложения SKOS-AP-EU' },
        { name: 'ЕМД', description: 'Единая модель данных ГИС ХББ' },
        { name: 'Пакет информационного обмена', description: 'Описание пакета информационного обмена' },
    ]
}

//
export const responseTaxonomyValues = {
    version: 1.0,
    concepts: [
        { concept: 'Модель предметной области (областей)', scheme: 'Степень детализации' },
        { concept: 'Модель обмена', scheme: 'Назначение' },
        { concept: 'SematicWeb', scheme: 'Парадигма проектирования' }
    ]
}

//Значения свойств Ассета
export const responseAsset = {
    version: 1.0,
    properties: [
        { name: 'URI (URI)', value: 'http://eurovoc.europa.eu/drupal/?q=ontology' },
        { name: 'Дата публикации (Date Issued)', value: '2016-02-01 00:00:00' },
        { name: 'Дата изменения (Date Modified)', value: '2016-05-22 00:00:00' }
    ]
}

//Значение списка групп документов/файлов
export const responseDocsGroup = {
    version: 1.0,
    groups: [
        { name: "Указы" },
        { name: "Федеральные законы" },
        { name: "Приказы" },
    ]
}

//Значение списка групп документов/файлов
export const responseDocs = {
    version: 1.0,
    docs: [
        { name: "Указ Президента Российской Федерации от 09.03.2004 №314 «О системе и структуре федеральных органов исполнительной власти»'" },
        { name: "Указ 2" },
        { name: "Указ 3" },
    ]
}

//Значения свойств Документов/Файлов
export const responseDoc = {
    version: 1.0,
    properties: [
        { name: 'Наименование', value: 'Указ Президента Российской Федерации от 09.03.2004 №314 «О системе и структуре федеральных органов исполнительной власти»' },
        { name: 'Описание', value: 'В целях формирования эффективной системы и структуры федеральных органов исполнительной власти, в соответствии со статьей 112 Конституции Российской Федерации и Федеральным конституционным законом от 17 декабря1997 г. N 2-ФКЗ "О Правительстве Российской Федерации" постановляю:' },
        { name: 'URI', value: 'urn:s2:cpgu_1-docs-document-1145' }
    ]
}

//История ЕМД
export const responseEMDHistory = {
    version: 1.0,
    assets: {
        data: [
            { name: 'Единая модель данных ГИС ХББ', description: 'Единая модель данных ГИС ХББ', NodId: 410 },
            { name: 'Единая модель данных ГИС ХББ от 01.03.19', description: 'Единая модель данных ГИС ХББ22', NodId: 1735 },
        ]
    }
} 

//Содержимое ЕМД
export const responseEMDContent = JSON.parse(JSON.stringify(emdOwlData));

//Содержимое паспорта пакета информационного обмена на основе owl
export const responseIEPContent = JSON.parse(JSON.stringify(iepOwlData));